import { render, staticRenderFns } from "./TetraRadioGroupSelect.vue?vue&type=template&id=1f36d7b6&scoped=true&lang=pug"
import script from "./TetraRadioGroupSelect.vue?vue&type=script&lang=js"
export * from "./TetraRadioGroupSelect.vue?vue&type=script&lang=js"
import style0 from "./TetraRadioGroupSelect.vue?vue&type=style&index=0&id=1f36d7b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36d7b6",
  null
  
)

export default component.exports